// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const PurchaseOrderService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

PurchaseOrderService.getGetPurchaseOrderItemService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    prospectid: data?.prospectid,
    applicationid: data?.applicationid,
    branchid: data?.branchid,
    startApplicationDate: data?.startApplicationDate,
    endApplicationDate: data?.endApplicationDate,
    name: data?.name,
  };
  return lossClient({
    url: `/PurchaseOrder/PurchaseOrder?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

PurchaseOrderService.addGetPurchaseOrderService = function (data) {
  return lossClient({
    url: `/PurchaseOrder/Add`,
    method: "post",
    headers: {},
    data: data,
  });
};

PurchaseOrderService.approvePurchaseOrderService = function (data) {
  return lossClient({
    url: `/PurchaseOrder/ApprovePurchaseOrder`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

PurchaseOrderService.getSearchListPoApprovalService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    prospectid: data?.prospectid,
    poNo: data?.poNo,
    branchId: data?.branchId,
    startPurchaseOrderDate: data?.startPurchaseOrderDate,
    endPurchaseOrderDate: data?.endPurchaseOrderDate,
    name: data?.name,
  };
  return lossClient({
    url: `/PurchaseOrder/SearchListPoApproval?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

PurchaseOrderService.getSearchListPoReleaseService = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    prospectid: data?.prospectid,
    poNo: data?.poNo,
    branchId: data?.branchId,
    startPurchaseOrderDate: data?.startPurchaseOrderDate,
    endPurchaseOrderDate: data?.endPurchaseOrderDate,
    name: data?.name,
  };
  return lossClient({
    url: `/PurchaseOrder/SearchListPoRelease?${buildQuery(params)}`,
    method: "get",
    headers: {},
  });
};

PurchaseOrderService.putPrintPurchaseOrderService = function (data) {
  return lossClient({
    url: `/PurchaseOrder/PrintPurchaseOrder`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

PurchaseOrderService.putSendEmailPurchaseOrderService = function (data) {
  return lossClient({
    url: `/PurchaseOrder/SendEmailPurchaseOrder`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

PurchaseOrderService.rejectPurchaseOrderService = function (data) {
  return lossClient({
    url: `/PurchaseOrder/RejectPurchaseOrder`,
    method: "put",
    headers: {
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

export default PurchaseOrderService;
